export { default as useMap } from './useMap';
export * from './useMap';
//# sourceMappingURL=index.js.map